import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Fade, IconButton } from '@mui/material';
import { useIntl } from 'react-intl';
import Tooltip from '@mui/material/Tooltip';
import LogoutIcon from '@mui/icons-material/Logout';
import Lottie from 'react-lottie-player';
import ai from 'assets/animation/ai.json';
import MDBox from 'components/MDBox';
import { useAuth } from 'hook/useAuth';
import { useGetParamByCodeQuery } from 'services/paramsApi';
import MDTypography from 'components/MDTypography';

export default function AppHome() {
  const { formatMessage: msg } = useIntl();
  const location = useLocation();
  const { logout } = useAuth();

  const { data: homeReportUrlParam } = useGetParamByCodeQuery('HOME_REPORT_URL');

  const [iframeAvailable, setIframeAvailable] = useState(false);
  const [checkingUrl, setCheckingUrl] = useState(true);

  const handleLogout = () => {
    logout();
  };

  const defaultState = {
    messageId: 'error.message.default',
    titleId: 'error.title.default',
    code: -1
  };

  const { code } = { ...defaultState, ...location.state };

  const reportUrl = homeReportUrlParam?.value || '';

  useEffect(() => {
    if (!reportUrl) {
      setCheckingUrl(false);
      return;
    }
    let cancelled = false;
    const checkUrl = async () => {
      try {
        const response = await fetch(reportUrl, { method: 'HEAD', mode: 'no-cors' });
        if (!cancelled) {
          setIframeAvailable(response.ok || response.type === 'opaque');
        }
      } catch {
        if (!cancelled) setIframeAvailable(false);
      } finally {
        if (!cancelled) setCheckingUrl(false);
      }
    };
    checkUrl();
  }, [reportUrl]);

  return (
    <Fade in timeout={(1000, 500)}>
      <MDBox
        flex={1}
        display="flex"
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
          m: 0,
          p: 0,
          position: 'relative'
        }}
      >
        {code >= 400 && code < 404 ? (
          <IconButton
            id="logoutBtn"
            color="text"
            variant="contained"
            onClick={handleLogout}
            aria-label={msg({ id: 'action.logout' })}
            sx={{ position: 'absolute', right: '5px', top: '5px', zIndex: 10 }}
          >
            <Tooltip title={msg({ id: 'action.logout' })}>
              <LogoutIcon fontSize="large" />
            </Tooltip>
          </IconButton>
        ) : null}

        {!checkingUrl && iframeAvailable ? (
          <iframe
            src={reportUrl}
            style={{
              width: '100%',
              height: '100%',
              border: 'none'
            }}
            allow="fullscreen"
            loading="lazy"
          />
        ) : (
          <MDBox
            display="flex"
            flexDirection={{ xs: 'column', xl: 'row' }}
            sx={{ alignItems: 'center' }}
            p={3}
          >
            <Lottie animationData={ai} style={{ width: 400 }} speed={0.5} loop play />
            <MDBox
              sx={{
                display: 'flex',
                flexDirection: 'column',
                width: { sx: '400px', xl: '600px' },
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <MDTypography variant="h2" color="text" mb={2}>
                Accueil
              </MDTypography>
              <MDTypography sx={{ textAlign: 'center' }}>
                {msg({ id: 'product.welcome' })}
              </MDTypography>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
    </Fade>
  );
}
